var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"icon-button",attrs:{"data-test":"navbar-import-button"},on:{"click":_vm.importFile}},[_c('HSIcon',{attrs:{"size":"","color":"","icon":"download"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }